import { type ChangeEvent } from 'react';
import { useTheme } from './theme.hook.tsx';
import { Themes } from './themes.ts';

export function ThemeSwitcher() {
    const [theme, setTheme] = useTheme();

    function onThemeChange(event: ChangeEvent<HTMLSelectElement>) {
        setTheme(event.target.value);
    }

    return (
        <>
            <select
                id="theme-select"
                className="rounded-full border self-stretch border-white/30 bg-white/10 px-3 py-1 text-[10px] font-semibold uppercase tracking-[0.25em] text-white/80 outline-none transition focus:ring-2 focus:ring-white/50 appearance-none"
                onChange={onThemeChange}
                value={theme.name}
            >
                {Themes.map((t) => (
                    <option key={t.name} value={t.name} className="text-foreground">{t.label}</option>
                ))}
            </select>
        </>
    );
}
